import React, { useContext } from 'react'

import { Card } from 'semantic-ui-react'
import { Typography, Box } from '@mui/material'

import { UserContext } from '../../../contexts/UserContext'
import UpgradeTag from '../../../components/common/UpgradeTag'
import FontPickerComponent from '../../../components/common/FontPickerComponent'
import ColorPicker from '../../../components/common/ColorPicker'
import { IProject } from '../../../api/Data'

const BrandingCard = (props: IProps) => {
  // Contexts
  const { userProfile } = useContext(UserContext)

  // Props
  const { project, handleChangePrimaryFont, handleChangePrimaryColor } = props

  const { displaySetting } = project

  const hasBrandedUploadPage = userProfile.plan.hasBrandedUploadPage

  return (
    <Card fluid style={{ width: '100%', boxSizing: 'border-box', height: '100%' }}>
      <Card.Content>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" fontWeight="bold">
            Project Branding
          </Typography>
          {!hasBrandedUploadPage && (
            <Box>
              <UpgradeTag
                title="Upgrade to add your branding"
                text="Upgrade your plan to add your branding to your landing page"
              />
            </Box>
          )}
          <Typography variant="h6">Font</Typography>
          <Box display="flex" flexDirection="row" justifyContent="space-between" gap={2}>
            <Box>
              <Typography variant="body2">Your font will apply to your landing page.</Typography>
            </Box>
            <Box
              width={250}
              sx={{
                opacity: hasBrandedUploadPage ? undefined : 0.5,
                pointerEvents: hasBrandedUploadPage ? undefined : 'none',
              }}
            >
              <FontPickerComponent activeFontFamily={displaySetting.primaryFont} onChange={handleChangePrimaryFont} />
            </Box>
          </Box>
          <Typography variant="h6">Primary Color</Typography>
          <Box display="flex" flexDirection="row" justifyContent="space-between" gap={2}>
            <Box>
              <Typography variant="body2">Your brand colors will be used to customize your landing page.</Typography>
            </Box>
            <Box
              width={80}
              sx={{
                position: 'relative',
                opacity: hasBrandedUploadPage ? undefined : 0.5,
                pointerEvents: hasBrandedUploadPage ? undefined : 'none',
              }}
            >
              <ColorPicker colorHex={displaySetting.primaryColor} onChange={handleChangePrimaryColor} />
            </Box>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}

interface IProps {
  project: IProject
  handleChangePrimaryFont: (arg: { family: string }) => void
  handleChangePrimaryColor: (arg: { hex: string }) => void
}

export default BrandingCard
